import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import apiClient from "../utils/apiClient";
import {
    Box,
    Container,
    Card,
    Typography,
    TextField,
    Button,
    CircularProgress,
    Paper,
    Grid,
  } from "@mui/material";
  import FallbackImage from "../components/FallbackImage";
import { getImageFullUrl, siteData } from "../utils/common";
import { useSelector } from "react-redux";

const ForgotPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [formFields, setFormsFields] = useState({
    email: '',
  });
    const [errors, setErrors] = useState({ email: "", });
  

  const history = useNavigate()
  const onChangeInput = (e) => {
    const { name, value } = e.target;
    setFormsFields(() => {
      return {
        ...formFields,
        [name]: value
      }
    })
  }

  const valideValue = Object.values(formFields).every(el => el)
  const logo = useSelector((state) => state.logo);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({ email: "", password: "" });

    let newErrors = {};
    if (!formFields.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formFields.email)) {
      newErrors.email = "Enter a valid email address";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsLoading(true);

    try {
        const res = await apiClient.post("/api/vendor/forgot-password", formFields);
        if (res?.data?.success) {
            toast.success(res?.data?.message || "Password reset link sent to your email");
            history('/login')
        } else {
          toast.error(res?.data?.message || "Failed to send link");
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || "Failed to send link");
      } finally {
        setIsLoading(false);
      }
  }

  return (
    <>
     <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#ebebeb",
          px: 2,
          py: 2,
        }}
      >
        <Paper
          elevation={4}
          sx={{
            maxWidth: 900,
            width: "100%",
            borderRadius: 3,
            overflow: "hidden",
          }}
        >
          <Grid container>
            {/* Left Side - Logo & Branding */}
            <Grid
              item
              size={{ xs: 12, md: 5 }}

              sx={{
                bgcolor: "primary.main",
                color: "white",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 6,
                px: 3,
                textAlign: "center",
              }}
            >
              <FallbackImage
                src={'/logo.png'}
                style={{ maxHeight: "80px", marginBottom: "20px" }}
              />
              <Typography variant="h4" fontWeight="bold">
                {siteData.name}
              </Typography>
              <Typography variant="body1" mt={2} sx={{ opacity: 0.85 }}>
                Welcome to the Vendor Panel.
              </Typography>
            </Grid>

            {/* Right Side - Signup Form */}
            <Grid item size={{ xs: 12, md: 7 }}
              sx={{ p: 4 }}>
              <h1 style={{ textAlign: 'center' }}>Forgot Password</h1>

              <form onSubmit={handleSubmit}>
                {/* Email */}
                <TextField
                  fullWidth
                  label="Email"
                  name='email'
                  // type="email"
                  margin="normal"
                  value={formFields.email}
                  disabled={isLoading}
                  onChange={onChangeInput}
                  error={!!errors.email}
                  helperText={errors.email}
                />
                <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              disabled={!valideValue || isLoading}
              sx={{
                py: 1.2,
                display: "flex",
                gap: 1,
              }}
            >
              {isLoading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Submit"
              )}
            </Button>
              </form>
              <br />
                {/* Back to Login */}
          <Typography align="center" variant="body2">
            Back to Login page{" "}
            <Link
            //   component={RouterLink}
              to="/login"
              underline="hover"
              sx={{ fontWeight: 600 }}
            >
              Login
            </Link>
          </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Box>
  </>
  );
};

export default ForgotPassword;
